import { SET_SESSION_ID } from './session-id-actions';

const defaultState = null;

/**
 * Session ID Reducer
 *
 * Consumes SET_SESSION_ID action
 *
 * @param {number} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {number} - current session id to send in backend requests
 */
export default function(state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
        case SET_SESSION_ID:
            return action.payload;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/app/session-id/session-id-reducer.js